// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3woJB","largestCol":"styles_largestCol__1gTq9","smallestCol":"styles_smallestCol__1s1By"};